export default __webpack_public_path__ + "media/images/deliveroo-white-df3535e8d7067e4ac2b492e96e64b0f9.svg";